import { useDialog } from "@datanac/datanac-mui-toolkit";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Tooltip from "@mui/material/Tooltip";
import { USER_ROLE_ADMIN, USER_ROLE_AGENT } from "core/useSession";

import { AccountLogoutIcon, LogoutIcon, PersonIcon } from "../../Icons/Icons";
import { CollapsedMenuItems } from "./CollapsedMenuItems";

/**
 * Component for rendering the collapsed menu content
 */
const CollapsedMenuContent = ({
  menuConfig,
  hoveredItem,
  membersMenuItem,
  pathname,
  handleNavigate,
  calculateIsModuleAllowed,
  handleMenuItemHover,
  handleMenuItemLeave,
  globalState,
  activeProducer,
  handleActiveUserSignoutClick,
  handleLogoutClick,
}) => {
  const { component: confirmDialog, actions: confirmDialogActions } = useDialog();

  const handleLogout = () => {
    confirmDialogActions.confirm({
      title: "Logout",
      prompt: "Are you sure you want to log out?",
      callback: handleLogoutClick,
    });
  };
  return (
    <>
      {confirmDialog}
      <CollapsedMenuItems
        menuConfig={menuConfig}
        hoveredItem={hoveredItem}
        globalState={globalState}
        calculateIsModuleAllowed={calculateIsModuleAllowed}
        pathname={pathname}
        handleMenuItemHover={handleMenuItemHover}
        handleMenuItemLeave={handleMenuItemLeave}
        handleNavigate={handleNavigate}
      />

      <Divider />
      <List>
        {membersMenuItem && membersMenuItem.condition(globalState) && (
          <Tooltip title="Members" placement="right">
            <ListItemButton
              className={pathname === membersMenuItem.path ? "active" : ""}
              onClick={() => handleNavigate(membersMenuItem.path)}
              sx={{
                justifyContent: "flex-start",
                minHeight: "48px",
                paddingX: 1.5,
                py: 1,
                borderRightStyle: "solid",
                borderRightWidth: "6px",
                borderRightColor: pathname === membersMenuItem.path ? "secondary.main" : "transparent",
              }}
            >
              <ListItemIcon sx={{ minWidth: 0, justifyContent: "center" }}>
                <membersMenuItem.icon color={pathname === membersMenuItem.path && "secondary"} />
              </ListItemIcon>
            </ListItemButton>
          </Tooltip>
        )}

        {Boolean(activeProducer?.producer_token) &&
          [USER_ROLE_ADMIN, USER_ROLE_AGENT].includes(globalState.user_role) && (
            <Tooltip title="Exit Viewing Account" placement="right">
              <ListItemButton
                onClick={handleActiveUserSignoutClick}
                sx={{
                  justifyContent: "flex-start",
                  minHeight: "48px",
                  paddingX: 1.5,
                  py: 1,
                }}
              >
                <ListItemIcon sx={{ minWidth: 0, justifyContent: "center" }}>
                  <AccountLogoutIcon />
                </ListItemIcon>
              </ListItemButton>
            </Tooltip>
          )}
      </List>
      <Divider />

      <List>
        <Tooltip title="User Profile" placement="right">
          <ListItemButton
            className={pathname === "/change-totp" ? "active" : ""}
            onClick={() => handleNavigate("/change-totp")}
            sx={{
              justifyContent: "flex-start",
              minHeight: "48px",
              paddingX: 1.5,
              py: 1,
              borderRightStyle: "solid",
              borderRightWidth: "6px",
              borderRightColor: pathname === "/change-totp" ? "secondary.main" : "transparent",
            }}
          >
            <ListItemIcon sx={{ minWidth: 0, justifyContent: "center" }}>
              <PersonIcon color={pathname === "/change-totp" && "secondary"} />
            </ListItemIcon>
          </ListItemButton>
        </Tooltip>

        <Tooltip title="Logout" placement="right">
          <ListItemButton
            onClick={handleLogout}
            sx={{
              justifyContent: "flex-start",
              minHeight: "48px",
              paddingX: 1.5,
              py: 1,
            }}
          >
            <ListItemIcon sx={{ minWidth: 0, justifyContent: "center" }}>
              <LogoutIcon />
            </ListItemIcon>
          </ListItemButton>
        </Tooltip>
      </List>
    </>
  );
};

export default CollapsedMenuContent;
